import { BFilter, BFilterableField } from '../BFilterEditor/BFilterEditor.types';
import { BSortOptions } from './BTable.types'
import { parseDate } from "@/utils"; 

function escapeFilterValue(value: any): string {
    if (typeof value == "string") {
        return `"${value.replace(/"/g, '\\"')}"`;
    }
    return value;
}

export function serializeFilters(filters: BFilter[], fields: BFilterableField[]): string {
    if(!filters || !fields){
        return "";
    }

    return filters
        .map((it) => {
            let field = fields.find((it2) => it2.property == it.property);
            if (field?.editorComponent == "date-editor") {
                // special handling for date fields
                // convert naive YYYY-MM-DD in user's zone to ISO8601 in UTC
                var value = parseDate(it.value,true);
                if (value) {
                    // greater than shouldn't include the current date
                    if (it.operation == "gt"){
                        value.setHours(value.getHours() + 24);
                    }
                    if (it.operation == "eq") {
                        // special handling for date equals: translate to 24h interval
                        const upper = new Date(value);
                        upper.setHours(upper.getHours() + 24);
                        return (
                            `${it.property}:ge:${escapeFilterValue(value.toISOString())},` +
                            `${it.property}:lt:${escapeFilterValue(upper.toISOString())}`
                        );
                    }
                    return `${it.property}:${it.operation}:${escapeFilterValue(value.toISOString())}`;
                } else {
                    return "Unsupported date format or no value.";
                }
            }
            if (it.value === undefined) {
                return `${it.property}:${it.operation}`;
            }
            return `${it.property}:${it.operation}:${escapeFilterValue(it.value)}`;
        })
        .join(",");
}

export function serializeSortBy(sortBy: BSortOptions[]): string {
    return sortBy.map(it => `${it.isDescending ? "-" : "+"}${it.key}`).join(",");
}